module.exports = __webpack_public_path__ + "static/media/cmk_headshot_2026.4816bcdf.jpg";